import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useParams, useNavigate } from "react-router";
import { Modal } from "react-bootstrap";
import PageBanner from "../layouts/PageBanner";
import bg from "../assets/images/banner/bnr4.jpg";
import avat1 from "../assets/images/avatar/avatar10.jpg";
import GallerySlider from "../components/Fundraiser/GallerySlider";
import { donate, getProject } from "../apis/Projects";
import { signup } from "../apis/Signup";
import { login } from "../apis/Login";
import { resetPassword } from "../apis/ResetPassword"; // Import from apis/resetPassword.js
import { AppContext } from "../context/AppContext";
import moment from "moment";
import DonateModal from "../components/Modal/DonateModal";
import ReactMarkdown from "react-markdown";
import AuthModal from "../components/AuthModal"; // Add this import

const ProjectDetails = () => {
  const [modalDonate, setModalDonate] = useState(false);
  const [referModal, setReferModal] = useState(false);
  // const [loading, setLoading] = useState(false);
  const [projectDetails, setProjectDetails] = useState(null);
  const [loginPromptModal, setLoginPromptModal] = useState(false); // Add this line
  const [showAuthModal, setShowAuthModal] = useState(false); // Add this line

  // const [success, setSuccess] = useState(false);
  const [donateProject, setDonateProject] = useState(null);
  // const [errors, setErrors] = useState({});
  

  const { handleLogOut, setUser, user } = useContext(AppContext);

  const [loginData, setLoginData] = useState({ email: "", password: "" });
  const [signupData, setSignupData] = useState({
    firstName: "",
    lastName: "",
    bio: "",
    role: "Role",
    email: "",
    password1: "",
    password2: "",
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(false);
  const [fundErrors, setFundErrors] = useState(false);

  // Modal visibility state
  const [showModal, setShowModal] = useState(false);

  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    getProjectDetails();
  }, []);

  const getProjectDetails = async () => {
    setLoading(true);
    try {
      let { data } = await getProject(id);

      setProjectDetails(data);
    } catch (error) {
      if (error.response?.status === 401) {
        handleLogOut();
      } else if (error.response?.status === 404) {
        navigate("/project");
      } else {
        setProjectDetails({});
        console.log(error);
      }
    }
    setLoading(false);
  };

  const submitDonation = async (e) => {
    e.preventDefault();

    if (!!donateProject && donateProject.amount == "") return;
    if (loading) return;
    setLoading(true);

    try {
      let response = await donate(donateProject);

      const donatedAmount = parseFloat(response?.data.amount);

      setUser((prevUser) => {
        const updatedUser = {
          ...prevUser,
          user: {
            ...prevUser.user,
            wallet_balance: (
              parseFloat(prevUser.user.wallet_balance) - donatedAmount
            ).toFixed(2),
          },
        };

        localStorage.setItem("user", JSON.stringify(updatedUser));
        return updatedUser;
      });

      setSuccess(true);
      getProjectDetails(id);
      setFundErrors({});
    } catch (error) {
      if (error.response?.status === 400) {
        setFundErrors(error.response?.data);
      } else if (error.response?.status === 401) {
        handleLogOut();
      } else {
        console.log(error);
      }
    }

    setLoading(false);
  };

  const handleFundClick = () => {
    if (Object.keys(user).length !== 0) {
      setDonateProject({
        projectID: projectDetails?.id,
        amount: "",
      });
      setModalDonate(true);
    } else {
      setLoginPromptModal(true);
    }
  };

  const handleLogin = async (loginData) => {
    setLoading(true);
    try {
      let response = await login(loginData);
      let result = response.data;
      setUser(result);
      localStorage.setItem("user", JSON.stringify(result));
      setErrors({});
      setShowAuthModal(false);
    } catch (error) {
      if (error.response?.status === 400 || error.response?.status === 401) {
        const responseData = error.response?.data;
        if (responseData.detail) {
          setErrors({ generic: [responseData.detail] });
        } else {
          setErrors(responseData);
        }
        localStorage.removeItem("user");
      } else {
        setErrors({
          email: ["Invalid credentials"],
          password: ["Wrong password"],
        });
        localStorage.removeItem("user");
      }
    }
    setLoading(false);
  };

  const handleSignup = async (signupData) => {
    if (loading) return;
    setLoading(true);

    try {
      let response = await signup(signupData);

      setSignupData({
        firstName: "",
        lastName: "",
        bio: "",
        role: "Role",
        email: "",
        password1: "",
        password2: "",
      });
      setSuccess(true);
      setErrors({});
    } catch (error) {
      if (error.response?.status === 400) {
        setErrors(error.response?.data);
      } else {
        setErrors({
          error: ["Something went wrong."],
        });
      }
    }
    setLoading(false);
  };

  const handleReset = async (email) => {
    setLoading(true);
    try {
      await resetPassword(email);
      setErrors({});
      setShowAuthModal(false);
    } catch (error) {
      setErrors({
        reset: ["No account found with this email address"],
      });
    }
    setLoading(false);
  };

  if (!projectDetails) return <h1>Loading ...</h1>;

  const projectOwner = {
    title: `${projectDetails.owner.first_name} ${projectDetails.owner.last_name}`,
    image: projectDetails.owner.profile_picture
      ? `https://api.kaf25.org${projectDetails.owner.profile_picture}`
      : avat1,
  };

  const customDescription = `
 **Utilizing robotics technology to minimize biodiversity loss in Saudi Arabia:**

##### **Tree Planting Robots:**
**These robots focus on directly addressing reforestation and habitat restoration by physically planting trees in areas where natural recovery is slow or impossible due to human activity or environmental degradation.**

##### **Seed-Spreading Drones:**
**These drones target seed dispersal on a large scale, including in hard-to-reach areas like steep slopes, deserts, and rugged terrains. Their application is particularly effective for revegetation, promoting biodiversity, and stabilizing ecosystems.**

##### **AI Analysis:**
**AI supports the solution by analyzing soil conditions, climate data, terrain topography, and biodiversity indices to optimize planting locations, species selection, and timing. This ensures efficiency and a higher success rate along with real-time monitoring.**
`;

  return (
    <>
      <div className="page-content bg-white">
        <PageBanner
          maintitle="Projects"
          pagetitle="Project Details"
          background={bg}
        />
        <section className="content-inner-2">
          <div className="container">
            <div className="row">
              <div className="col-xl-8 col-lg-8 m-b30">
                <div className="fundraiser-single">
                  <div className="swiper fundraiser-gallery-wrapper">
                    {/* <GallerySlider /> */}
                    <div className="dz-media">
                      <img src={projectDetails?.image} alt="" />
                    </div>
                  </div>
                  <h2 className="title">{projectDetails?.title}</h2>
                  {projectDetails?.id ===
                  "b6edc041-ac3e-42b8-b25e-f4cf7a611420" ? (
                    <ReactMarkdown>{customDescription}</ReactMarkdown>
                  ) : (
                    <p>{projectDetails?.description}</p>
                  )}
                  <div className="progress-bx style-1">
                    <ul className="progress-tag">
                      <li className="raised">
                        <i className="lar la-calendar"></i> Start:{" "}
                        <span className="text-primary">
                          {moment(projectDetails?.start_date).format(
                            "DD-MM-YYYY"
                          )}
                        </span>
                        y
                      </li>
                      <li>
                        <Link to={`/project-details/${projectDetails?.id}`}>
                          {projectDetails?.category}
                        </Link>
                      </li>{" "}
                      <li className="goal">
                        <i className="lar la-calendar"></i> End:{" "}
                        <span className="text-primary">
                          {moment(projectDetails?.end_date).format(
                            "DD-MM-YYYY"
                          )}
                        </span>
                      </li>
                    </ul>
                  </div>

                  <ul className="fundraiser-bottom">
                    <li>
                      <button
                        className="btn btn-donate btn-primary btn-sm"
                        onClick={handleFundClick}
                      >
                        Fund
                      </button>
                    </li>
                    <li>
                      <button
                        className="btn btn-secondary btn-sm"
                        onClick={() =>
                          window.open(
                            "https://docs.google.com/forms/d/e/1FAIpQLSfwgw3NFpkcmiMg0vnXXs0HfPbPmXy_J8EaX7IwgposF_3Pgw/viewform?usp=header",
                            "_blank"
                          )
                        }
                      >
                        Connect
                      </button>
                    </li>
                    <li>
                      <a
                        href="https://docs.google.com/forms/d/e/1FAIpQLScWhYH4jpttXuNyzgeltgCfZ_tV3iLmgr9twb_8QAJWI_U-1w/viewform?usp=header"
                        target="_blank"
                        rel="noreferrer"
                        className="btn facebook btn-primary btn-sm"
                      >
                        Volunteer
                      </a>
                    </li>
                  </ul>
                </div>
                {/* <div className="widget style-1 widget_refer">
                  <div className="widget-title">
                    <h4 className="title">Refer a Friend</h4>
                  </div>
                  <p>
                    In need of funds for medical treatment or know someone who
                    might be? Share the details and Akcel will get in touch
                    with.
                  </p>
                  <Link
                    to={"#"}
                    className="btn btn-outline-primary"
                    onClick={() => setReferModal(true)}
                  >
                    Refer Now
                  </Link>
                </div> */}
              </div>

              <div className="col-xl-4 col-lg-4">
                <aside className="side-bar sticky-top">
                  <div className="widget style-1 widget_donate">
                    <button
                      className="btn btn-donate btn-primary w-100"
                      onClick={handleFundClick}
                    >
                      Fund
                    </button>
                    <button
                      className="btn btn-secondary w-100"
                      onClick={() =>
                        window.open(
                          "https://docs.google.com/forms/d/e/1FAIpQLSfwgw3NFpkcmiMg0vnXXs0HfPbPmXy_J8EaX7IwgposF_3Pgw/viewform?usp=header",
                          "_blank"
                        )
                      }
                    >
                      Connect
                    </button>
                    <a
                      href="https://docs.google.com/forms/d/e/1FAIpQLScWhYH4jpttXuNyzgeltgCfZ_tV3iLmgr9twb_8QAJWI_U-1w/viewform?usp=header"
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-primary facebook w-100 btn-bottom"
                    >
                      Volunteer
                    </a>
                  </div>

                  {/* <!--  Widget Fund --> */}
                  <div className="widget style-1 widget_fund">
                    <h3 className="title">
                      SAR {projectDetails?.total_pledged}
                    </h3>
                    <p>
                      raised of <span>SAR {projectDetails?.goal_amount}</span>{" "}
                      goal
                    </p>
                    <div className="progress-bx style-1">
                      <div className="progress">
                        <div
                          className="progress-bar progress-bar-secondary progress-bar-striped progress-bar-animated"
                          role="progressbar"
                          style={{ width: projectDetails?.progress + "%" }}
                        ></div>
                      </div>
                    </div>
                    <ul className="detail">
                      <li className="d-flex">
                        <h5>{projectDetails?.number_of_donations}</h5>
                        <span className="ms-2">supporters</span>
                      </li>
                      <li className="d-flex">
                        <h5>{projectDetails?.days_left}</h5>
                        <span className="ms-2">days left</span>
                      </li>
                    </ul>
                  </div>

                  {/* <!-- Fundraising Team --> */}
                  <div className="widget style-1 widget_avatar">
                    <div className="widget-title">
                      <h5 className="title">Project Owner</h5>
                    </div>
                    <div className="avatar-wrapper">
                      <div className="avatar-item">
                        <div className="avatar-media">
                          <img src={projectOwner.image} alt="" />
                        </div>
                        <div className="avatar-info">
                          <h6 className="title">
                            <Link to={"#"}>{projectOwner.title}</Link>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </aside>
              </div>
            </div>
          </div>
        </section>
      </div>
      <DonateModal
        donateProject={donateProject}
        setDonateProject={setDonateProject}
        submitDonation={submitDonation}
        loading={loading}
        success={success}
        setSuccess={setSuccess}
        errors={fundErrors}
      />
      <Modal
        show={loginPromptModal}
        onHide={() => setLoginPromptModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Login Required</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>You need to log in to fund this project.</p>
          <button
            className="btn btn-primary"
            onClick={() => {
              setLoginPromptModal(false);
              setShowAuthModal(true);
            }}
          >
            Go to Login
          </button>
        </Modal.Body>
      </Modal>
      <AuthModal
        show={showAuthModal}
        onHide={() => setShowAuthModal(false)}
        mode="login"
        onLogin={(data) => handleLogin(data)}
        onSignup={(data) => handleSignup(data)}
        onReset={(email) => handleReset(email)}
        errors={errors}
        loading={loading}
        success={success}
        setSuccess={setSuccess}
      />
    </>
  );
};

export default ProjectDetails;
